import script from "./error.vue?vue&type=script&setup=true&lang=js"
export * from "./error.vue?vue&type=script&setup=true&lang=js"

import "./error.vue?vue&type=style&index=0&id=d3d1556a&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3d1556a"]])

export default __exports__